import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { Box, Container, Typography, Grid } from "@mui/material";
import compact from "../../image/compact.png";
import energy from "../../image/energy.png";
import aqua from "../../image/aqua.png";
import { SectionTitle } from "../FramelessSelect/FramelessSelect.styled";
import UnitTypeCard from "./UnitTypeCard";
import { useSelector } from "react-redux";
import { brandTranslation } from "../../utils/brandUtils";

const UnitTypeSelector = ({ onClose }) => {
  const { t } = useTranslation();
  const { isClivet } = useSelector((state) => state.brand);
  const navigate = useNavigate();
  const { projectId } = useParams();

  const handleSelect = (unitTypeId) => {
    navigate(
      `/create-project/${projectId}/configurator/${unitTypeId}?isEditing=false`
    );
    if (onClose) {
      onClose();
    }
  };

  const baseUnitTypes = [
    {
      id: 1,
      title: t(
        brandTranslation("framelessSelect.productCards.compactAhu.title")
      ),
      description: t(
        brandTranslation("framelessSelect.productCards.compactAhu.description")
      ),
      buttonText: t(
        brandTranslation("framelessSelect.productCards.compactAhu.buttonText")
      ),
      image: compact,
    },
  ];

  let unitTypes = [...baseUnitTypes];

  unitTypes.push({
    id: 2,
    title: t(
      brandTranslation("framelessSelect.productCards.energyAhu.title")
    ),
    description: t(
      brandTranslation("framelessSelect.productCards.energyAhu.description")
    ),
    buttonText: t(
      brandTranslation("framelessSelect.productCards.energyAhu.buttonText")
    ),
    image: energy,
    alt: "Energy Prime:Pro",
    disabled: false,
  });

  unitTypes.push({
    id: 6,
    title: t(brandTranslation("framelessSelect.productCards.linePrimeAhu.title")),
    description: t(brandTranslation("framelessSelect.productCards.linePrimeAhu.description")),
    buttonText: t(brandTranslation("framelessSelect.productCards.linePrimeAhu.buttonText")),
    image: null,
    //alt: "Line Prime",
    disabled: false,
  });

  if (!isClivet) {
    unitTypes.push({
      id: 4,
      title: t("framelessSelect.productCards.aquaAhu.title", {
        defaultValue: "AQUA:PRIME",
      }),
      description: t("framelessSelect.productCards.aquaAhu.description", {
        defaultValue:
          "Advanced water-based solution for specialized applications.",
      }),
      buttonText: t("framelessSelect.productCards.aquaAhu.buttonText", {
        defaultValue: "Select Aqua:Prime AHU",
      }),
      image: energy,
      alt: "Aqua Prime:Pro",
      disabled: true,
      comingSoon: t("framelessSelect.comingSoon", {
        defaultValue: "Coming Soon",
      }),
    });
  }

  return (
    <Container maxWidth="lg" sx={{ py: 8 }}>
      <Box sx={{ textAlign: "center", mb: 6 }}>
        <SectionTitle
          variant="h3"
          component="h2"
          sx={{
            fontSize: { xs: "2rem", md: "3rem" },
            mb: 2,
          }}
        >
          {t("framelessSelect.getStartedTitle", {
            defaultValue: "SELECT UNIT TYPE",
          })}
        </SectionTitle>
        <Typography
          variant="h6"
          sx={{
            color: "text.secondary",
            maxWidth: "600px",
            mx: "auto",
            fontSize: { xs: "1.1rem", md: "1.25rem" },
            fontWeight: 400,
            lineHeight: 1.6,
          }}
        >
          {t("framelessSelect.chooseAhuType", {
            defaultValue: "Choose your AHU type:",
          })}
        </Typography>
      </Box>

      <Grid container spacing={4} justifyContent="center">
        {unitTypes.map((unit, index) => (
          <Grid item xs={12} md={6} lg={4} key={unit.id}>
            <UnitTypeCard
              id={unit.id}
              title={unit.title}
              description={unit.description}
              buttonText={unit.buttonText}
              image={unit.image}
              alt={unit.alt}
              disabled={unit.disabled}
              comingSoon={unit.comingSoon}
              onSelect={handleSelect}
              index={index}
            />
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default UnitTypeSelector;
